import { TagListItem } from '@/models/common/tag-list-item.model';
import { BaseNamedItem } from '@/models/common/base-named-item.model';

export type PayoutOrderListItemResponse = {
  createdAt: number;
  playerId: string;
  amount: string;
  psp: string;
  currency: string;
  playerEmail: string;
  bpWlTransactionModerationInfoId?: string | null;
  moderateBackOfficeAdminId?: string | null;
  moderateBackOfficeAdminEmail?: string | null;
  moderateStatus?: string | null;
  billingProviderId?: string | null;
  playerTagList: PayoutOrderPlayerTagListItem[];
  playerSegmentList: PayoutOrderPlayerSegmentListItem[];
  paymentStatusInfo: string[];
  blockHoldMessage?: string | null;
  whitelabelSlug: string;
  bpWlTransactionId: string;
  transactionStatus?: string;
  takeableTransaction: boolean;
  processingType?: string | null;
  paymentSystem?: string | null;
  payoutStatus?: string;
  isModerationAvailable?: boolean;
  maskedFieldList?: string[];
};

export type PayoutOrderListItem = {
  createdAt: string;
  playerEmail: string;
  playerId: string;
  playerTagList: PayoutOrderPlayerTagListItem[];
  transactionStatus?: string;
  amount: string;
  psp: string;
  processingType?: string | null;
  moderateBackOfficeAdminEmail?: string | null;
  actionType?: string | null;
  whitelabelSlug: string;
  takeableTransaction: boolean;
  isModerationAvailable?: boolean;
  isDisabledPopover: boolean;
  isPaymentStatusInfo: boolean;
  paymentStatusInfo: string[];
  isBlockHoldMessage: boolean;
  blockHoldMessage?: string | null;
  transactionStatusTagName: string;
  bpWlTransactionId: string;
};

export type PayoutOrderPlayerTagListItem = TagListItem

export type PayoutOrderPlayerSegmentListItem = BaseNamedItem;

export enum PayoutOrderColumnProperties {
  CREATED_AT = 'createdAt',
  WHITELABEL_SLUG = 'whitelabelSlug',
  PLAYER = 'player',
  PLAYER_EMAIL = 'playerEmail',
  PLAYER_ID = 'playerId',
  PLAYER_TAG_LIST = 'playerTagList',
  AMOUNT = 'amount',
  PSP = 'psp',
  PROCESSING_TYPE = 'processingType',
  TRANSACTION_STATUS = 'transactionStatus',
  MODERATE_BACK_OFFICE_ADMIN_EMAIL = 'moderateBackOfficeAdminEmail',
  ACTIONS = 'actions',
  ACTION_TYPE = 'actionType',
  IS_DISABLED_POPOVER = 'isDisabledPopover',
  IS_PAYMENT_STATUS_INFO = 'isPaymentStatusInfo',
  PAYMENT_STATUS_INFO = 'paymentStatusInfo',
  IS_BLOCK_HOLD_MESSAGE = 'isBlockHoldMessage',
  BLOCK_HOLD_MESSAGE = 'blockHoldMessage',
  TRANSACTION_STATUS_TAG_COLOR = 'transactionStatusTagColor',
  TRANSACTION_STATUS_TAG_NAME = 'transactionStatusTagName',
}

export enum ProcessingType {
  MANUAL = 'manual',
  AUTO = 'auto',
}

export enum TransactionStatus {
  KYC_VERIFICATION = 'kycVerification',
  MODERATION = 'moderation',
  MODERATION_PROCESS = 'moderationProcess',
  WAIT = 'wait',
  CANCEL = 'cancel',
  DONE = 'done',
  PROCESSED = 'processed',
  PENDING = 'pending',
  HOLD = 'hold',
  CANCELLED = 'cancelled',
  UNCOMPLETED = 'uncompleted',
  PAID = 'paid',
  INITIATED = 'initiated',
  MANUAL_CANCEL = 'manualCancel',
  MANUAL_PAID = 'manualPaid',
  WAITING_PSP_COMPLETION = 'waitingPSPCompletion',
  FRAUD_CANCELLED = 'fraudCancelled',
  STUCK = 'stuck',
}

export type PayoutOrderActionButton = {
  label: string;
  type: 'text' | 'default' | 'primary' | 'success' | 'warning' | 'info' | 'danger';
}

export enum PayoutOrderAction {
  TAKE = 'take',
  DROP = 'drop',
  MANUAL_FLOW = 'manualFlow',
  FORCE_TAKE = 'forceTake',
}
